import type { FiatPrice } from "@b2bportal/air-shopping-api";
import type { CreditCard } from "@b2bportal/card-api";
import type {
  WalletCreditTransaction,
  WalletCreditSummaryResponse,
} from "@b2bportal/hsbc-wallet-api";
import { createSelector } from "@reduxjs/toolkit";
import walletApi from "./api";

// Account rewards API selectors
export const getCreditBalance = (
  creditSummary: WalletCreditSummaryResponse
): FiatPrice => creditSummary?.balance;

export const getCreditHistoryTransactions = (
  creditSummary: WalletCreditSummaryResponse
): Array<WalletCreditTransaction> => creditSummary?.transactions;

export const walletCreditSummaryResultSelector =
  walletApi.endpoints.getWalletCreditSummary.select();

export const creditSummarySelector = createSelector(
  walletCreditSummaryResultSelector,
  (result) => result.data
);

export const walletEarnResultSelector =
  walletApi.endpoints.getWalletCreditEarn.select();

export const walletEarnSelector = createSelector(
  walletEarnResultSelector,
  (result) => result.data?.eligibleEarns || []
);

export const creditBalanceSelector = createSelector(
  creditSummarySelector,
  getCreditBalance
);

export const creditTransactionsSelector = createSelector(
  creditSummarySelector,
  getCreditHistoryTransactions
);

// List cards selectors
export const getListCards = (listCards): Array<CreditCard> =>
  listCards?.value || [];

export const listCardsResultSelector =
  walletApi.endpoints.listPaymentMethods.select("listCards");

export const listCardsSelector = createSelector(
  listCardsResultSelector,
  (result) => result.data
);

export const selectCards = createSelector(listCardsSelector, getListCards);
